import { DataLoader, withData as loader } from '@ott/utility-loader';

import { createReducer } from '@reduxjs/toolkit';

import { RequestError } from '../../types';
import { check3ds } from './actions';
import { RequestResponse } from './types';

const initialState: DataLoader<RequestResponse, RequestError> = loader.initial();

const check3dsReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(check3ds.pending, () => loader.begin())
    .addCase(check3ds.fulfilled, (_, { payload }) => loader.success(payload))
    .addCase(check3ds.rejected, () => loader.error());
});

export default check3dsReducer;
